import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

export const useUpdateOpportunityMutation = ({
	impersonationContext,
	onError,
	onSuccess,
}: {
	impersonationContext?: Api.IImpersonationContext;
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: (data: Api.IOpportunity) => void;
} = {}) => {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: (opportunity: Api.IOpportunity) => {
			return userSession.webServiceHelper.callAsync<Api.IOpportunity>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: `board/item/${opportunity.id}/opportunity`,
				}),
				'PUT',
				opportunity
			);
		},
		onError,
		onSuccess,
	});
};
